const defaultState = {
  isFirstFetching: false,
  isAdvancedSearchEnabled: false,
};

function plazaChargerList(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'FIRST_FETCHING':
      return { ...state, isFirstFetching: action.isFirstFetching };
    case 'TOGGLE_ADVANCED_SEARCH_ENABLED':
      return { ...state, isAdvancedSearchEnabled: action.isAdvancedSearchEnabled };
    default:
      return state;
  }
}

export default plazaChargerList;
